module.exports = __webpack_public_path__ + "img/twitter-icon.f619a77f.svg";